import React, { Fragment, useState, useEffect } from "react";
import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import { SRLWrapper } from "simple-react-lightbox";
import profile01 from "../../../../images/profile/1.jpg";
import RctCollapsibleCard from "../RctCollapsibleCard/RctCollapsibleCard";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import { NotificationManager } from "react-notifications";
import MUIDataTable from "mui-datatables";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/Step";
import StepButton from "@material-ui/core/StepButton";
import { Form, FormGroup, Label, Input } from "reactstrap";
import Select from "react-select";
import {
  withGoogleMap,
  GoogleMap,
  withScriptjs,
  InfoWindow,
  Marker,
} from "react-google-maps";
import Autocomplete from "react-google-autocomplete";
import { CardTitle, CardBody } from "reactstrap";

import {
  Table,
  Badge,
  Row,
  Card,
  Col,
  Button,
  Container,
  ListGroup
} from "react-bootstrap";

import {
  Pagination,
  PaginationItem,
  PaginationLink,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from "reactstrap";

import ReactPanZoom from "react-image-pan-zoom-rotate";
import { TimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { GetOutletTimingList } from "../../../../apiservicescall/api";

/* import PageTitle from "../../../layouts/PageTitle"; */
//** Import Image */
/* import profile01 from "../../../../images/profile/1.jpg"; */
import profile02 from "../../../../images/profile/2.jpg";
import profile03 from "../../../../images/profile/3.jpg";
import profile04 from "../../../../images/profile/4.jpg";
import profile05 from "../../../../images/profile/5.jpg";
import profile06 from "../../../../images/profile/6.jpg";
import profile07 from "../../../../images/profile/7.jpg";
import profile08 from "../../../../images/profile/8.jpg";
import profile09 from "../../../../images/profile/9.jpg";
import profile from "../../../../images/profile/profile.png";
import img3 from "../../../../images/card/44.png";
import img6 from "../../../../images/card/img6.jpg";
import PageTitle from "../../../layouts/PageTitle";
import { setNestedObjectValues } from "formik";

import swalMessage from "@sweetalert/with-react";
import swal from "sweetalert";
import {
  updatePWDstaffDetails
} from "../../../../apiservicescall/api";


const PwdChange = ({ props }) => {
  const [password, setPassword] = useState("");
  const [resetpassword, setResetpassword] = useState("");
  const [userDetails, setUserDetails] = useState(
    JSON.parse(localStorage.getItem("userDetails"))
  );

  // const onSubmit = (e) => {
  //   e.preventDefault();
  //   history.push("/dashboard");
  // };

  useEffect(() => {
    console.log("userDetails1232", userDetails);
    pwdchecl();
  }, []);


  const pwdchecl = () => {
    if (userDetails?.firstLoginStatus == "Y") {
      swalMessage(
        <div>
          <h2>Kindly Update Your Password !!</h2>
        </div>
      )
    }
  }

  const updatePWDstaff = async () => {

    let compCode = userDetails?.companyCode;
    let outletCode = userDetails?.outletResponses[0]?.outletCode;
    let password = resetpassword;
    let userId = userDetails?.userId;

    let reqforupload = await updatePWDstaffDetails(
      compCode,
      outletCode,
      password,
      userId);

    if (reqforupload?.status === 200) {
      swal("Success!", "Password Updated Succcesfully", "success");
      localStorage.clear(); //all items

      window.location.replace('#/login');
      window.location.reload(true);
      //   // await this.setState({ reload: false });
      //   // NotificationManager.success("Success");
      //   // this.setState({ addNewUserModal: false, loading: true });
    } else {
      //   // await this.setState({ reload: false });
      //   // NotificationManager.warning("Invalid Data Format");
      //   // this.setState({ addNewUserModal: true });
      swal("Oops", "Error, Please Try Later", "error");

      //   setIsview(false);
      //   setIsedit(false);
      //   setLargeModal(!largeModal);
      //   getstaffMasterList();
    }
  };



  return (

    <div className="col-md-10">
      <Card>
        <Card.Header className="card-title">
          Reset Password
        </Card.Header>
        <Card.Body>
          <div style={{ marginLeft: "30px" }}>
            <div className="col-md-6">
              <label className="">
                <strong>Password</strong>
              </label>
              <input
                type="password"
                className="form-control"
                maxLength={20}
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value)
                }
                }
              />
            </div>

            <div className="col-md-6">
              <label className="">
                <strong>Retype Password</strong>
              </label>
              <input
                type="password"
                className="form-control"
                maxLength={20}
                value={resetpassword}
                onChange={(e) => {
                  setResetpassword(e.target.value)
                }
                }
              // defaultValue="hello@example.com"
              />
            </div>
            <br />
            <div className="col-md-4">
              <button
                type="submit"
                disabled={(resetpassword != password) || (resetpassword == "")}
                className="btn btn-primary btn-block"
                onClick={() => {
                  updatePWDstaff()
                }}
              >
                SUBMIT
              </button>
            </div>
          </div>

        </Card.Body>

        <Card.Footer>
          <Card.Text className=" d-inline" style={{ color: "red" }}>NOTE: You will be redirect to login page, after Reset the Password</Card.Text>

        </Card.Footer>


      </Card>
    </div>
  );
};
export default PwdChange;